import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { SVButton } from '@/components/core';
import { useDeleteBankApplication } from '@/hooks/requests/useBankApplications';
import showToast from '@/utils/toast';
import { MESSAGES } from '@/constants/messages';
import { useNavigate } from 'react-router-dom';

type BankApplicationDeleteDialogProps = {
  uuid: string;
  applicationId: string;
  ownerName: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  navigateRoute?: string;
};

export default function BankApplicationDeleteDialog({
  uuid,
  applicationId,
  ownerName,
  open,
  setOpen,
  navigateRoute,
}: BankApplicationDeleteDialogProps) {
  const navigate = useNavigate();
  const { deleteBankApplication, isDeleteBankApplicationPending } =
    useDeleteBankApplication();

  async function handleConfirm() {
    try {
      await deleteBankApplication(uuid);
      showToast({
        type: 'success',
        data: {
          content: 'Bank application has been successfully deleted',
        },
      });
      setOpen(false);
      if (navigateRoute) {
        navigate(navigateRoute);
      }
    } catch {
      showToast({
        type: 'error',
        data: {
          content: MESSAGES.genericError,
        },
      });
    }
  }

  return (
    <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <Box>
          <Typography variant="h6" component="h2">
            Delete Bank Application
          </Typography>
          <Typography sx={{ mt: 2 }}>
            Are you sure you want to delete the bank application for "
            {ownerName}" (Application ID: {applicationId})? Deleting is
            permanent and cannot be undone.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <SVButton onClick={() => setOpen(false)} variant="tertiary">
          No, Don't Delete
        </SVButton>
        <SVButton
          onClick={handleConfirm}
          variant="error"
          isLoading={isDeleteBankApplicationPending}>
          Yes, Delete
        </SVButton>
      </DialogActions>
    </Dialog>
  );
}
